import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";

import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";

import Api from "../../services/api";

import * as componentActions from "../../redux/actions/breakreasons";
import clsx from "clsx";
import PropTypes from "prop-types";
import { AbilityContext } from "../../config/ability-context";

import moment from "moment";
import { formatIntervalToReadable } from "src/utils/breakReason";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  CircularProgress,
  Container,
  CssBaseline,
  Grid,
} from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Pagination from "@mui/material/Pagination";
import Typography from "@mui/material/Typography";
import { withStyles } from "@mui/styles";

import { Overlay } from "../../styles/global";
import { Styles } from "../../styles/material-styles";

import FirstElement from "../../components/first-element";
import Footer from "../../components/footer";
import HeaderMenu from "../../components/header-menu";
import CustomizedSnackbars from "../../components/material-snackbars";
import MyMaterialTable from "../../components/table";
import SimpleDatePicker from '../../components/date-pickers/inline-no-today'

import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AddIcon from "@mui/icons-material/Add";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

class BreakWorkMeList extends Component {
  constructor(props) {
    super(props);

    const { userSession, intl } = this.props;

    if (userSession == null || userSession.user == null || userSession.user.userrole == null)
      Api.logoff()

    this.state = {
      dataFilter: false,
      loading: false,

      openNotification: false,
      notificationVariant: "error",
      notificationMessage: "",
      resultList: [],

      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0,

      dateStart: moment(),
      dateEnd: moment(),

      columns: [
        { title: intl.formatMessage({ id: "break.work.table.reason" }), field: 'reasonbreak.name' },
        { title: intl.formatMessage({ id: "break.work.table.start" }), field: 'startdate' },
        { title: intl.formatMessage({ id: "break.work.table.end" }), field: 'enddate' },
        { title: intl.formatMessage({ id: "break.work.table.duration" }), field: 'breakduration' },
        { title: intl.formatMessage({ id: "break.work.table.limit" }), field: 'breaklimit' },
        { title: intl.formatMessage({ id: "break.work.table.exceeded" }), field: 'overflowtime' },
      ]
    };

    this.closeNotification = this.closeNotification.bind(this);
    this.getItens = this.getItens.bind(this);
    this.clearFields = this.clearFields.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.state === "reload") {
      this.componentDidMount();
    }
  }

  async componentDidMount() {
    await this.getItens();
  }

  async clearFields() {
    await this.setState({ dateStart: moment(), dateEnd: moment(), page: 1, loading: true });

    await this.getItens(1);
  }

  async getItens(page = 1) {
    this.setState({ loading: true });

    if (this.state.dateStart > this.state.dateEnd) {
      const { intl } = this.props;

      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "report.audit.initial.date.higher.than.end.date" }),
        loading: false
      });

      return;
    }

    const diffMonths = moment(this.state.dateEnd).diff(moment(this.state.dateStart), 'months', true);
    if (diffMonths > 6) {
      const { intl } = this.props;

      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "report.date.range.exceeds.six.months" }),
        loading: false
      });

      return;
    }

    let url = `/break-work/paginate?page=${page}`;

    if (this.state.dateStart != "")
      url += `&dateStart=${moment(this.state.dateStart).format('YYYY-MM-DD')}`

    if (this.state.dateEnd != "")
      url += `&dateEnd=${moment(this.state.dateEnd).format('YYYY-MM-DD')}`

    await Api.get(url)
      .then((result) => {
        if (result.data.success) {
          const data = result.data.data;
          let count = result.data.count;

          this.setState({ count: count });
          this.setPagination(count, page);

          const formattedList = data.map((item) => {
            return {
              ...item,
              startdate: item.startdate ? moment.utc(item.startdate).format('DD/MM/YYYY HH:mm:ss') : '',
              enddate: item.enddate ? moment.utc(item.enddate).format('DD/MM/YYYY HH:mm:ss') : '',
              breaklimit: formatIntervalToReadable(item.breaklimit),
              breakduration: formatIntervalToReadable(item.breakduration),
              overflowtime: item.overflowtime ? formatIntervalToReadable(item.overflowtime) : 'Não execedeu',
            };
          });

          this.setState({ loading: false, resultList: formattedList });
        } else {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "error",
            notificationMessage:
              result.data &&
                result.data.response &&
                result.data.response.data &&
                result.data.response.data.errors &&
                result.data.response.data.errors[0]
                ? result.data.response.data.errors[0]
                : intl.formatMessage({ id: "process.error" }),
          });
          Api.kickoff(result);
        }
      })
      .catch((err) => {
        const intl = this.props.intl;
        this.setState({
          loading: false,
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            err.response &&
              err.response.data &&
              err.response.data.errors &&
              err.response.data.errors[0]
              ? err.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(err);
      });
  }

  onChangePaginate = async (e, page) => {
    this.setState({ page: page });
    await this.getItens(page);
  };

  setPagination(count, page) {
    let totalPage = Math.ceil(count / 10);
    this.setState({ totalPages: totalPage });
    if (count > 0) {
      if (page == 1) {
        if (count < 10) {
          this.setState({ pageStart: 1, pageEnd: count });
        } else {
          this.setState({ pageStart: 1, pageEnd: 10 });
        }
      } else {
        let pageStart = (page - 1) * 10 + 1;

        if (count >= page * 10) {
          this.setState({ pageStart: pageStart, pageEnd: page * 10 });
        } else {
          this.setState({ pageStart: pageStart, pageEnd: count });
        }
      }
    } else {
      this.setState({ totalPages: 0, page: 1, count: 0 });
    }
  }

  changeValues = async (stateName, value, text = '') => {
    this.setState({ loading: true })

    this.setState({ [stateName]: value });

    this.setState({ loading: false })
  };

  closeNotification() {
    this.setState({ openNotification: false });
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props;
    const intl = this.props.intl;

    if (Api == null) {
      var l = this.props.match.params.lang;
      document.location.href = `/${l}/unavailable`;
    }

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(
            classes.content,
            {
              [classes.contentShift]: headerMenu.open,
            },
            classes.actionsContent,
            {
              [classes.actionscontentShift]: actionsHeaderMenu.open,
            }
          )}
        >
          <div className={classes.drawerHeader} />

          <Container
            component="main"
            maxWidth="xl"
            style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}
          >

            <div>
              <CssBaseline />
              <Grid container className={classes.mb20} spacing={0}>
                <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  className={classes.button}
                  startIcon={<AddIcon />}
                  component={Link}
                  {...{
                    to: `/${this.props.match.params.lang}/break-reason-start`,
                  }}
                >
                  {<FormattedMessage id="menu.register.break" />}
                </Button>
              </Grid>
              <Grid container spacing={6} alignItems="center">
                <Grid item xs={12} sm={12}>
                  <Card className="background-title-search">
                    <CardContent>
                      <Grid container spacing={1} alignItems="center">
                        <Grid item xs={12} sm={5} md={3} lg={6}>
                          <Typography variant="h5">
                            {<FormattedMessage id="menu.breakwork.me" />}
                          </Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>

              <form name='myForm' className={classes.form} encType='multipart/form-data'>
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography className={classes.heading}>{intl.formatMessage({ id: "filters" })}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container style={{ marginBottom: 10 }} spacing={2}>
                      <Grid item xs={12} sm={6} md={4}  >
                        <SimpleDatePicker label={intl.formatMessage({ id: "start.date" })} name='dateStart' stateName='dateStart' changeDate={this.changeValues} currentDate={this.state.dateStart} fullWidth={true} required />
                      </Grid>
                      <Grid item xs={12} sm={6} md={4} >
                        <SimpleDatePicker label={intl.formatMessage({ id: "end.date" })} name='dateEnd' stateName='dateEnd' changeDate={this.changeValues} currentDate={this.state.dateEnd} fullWidth={true} required />
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                <Grid container style={{ marginBottom: 10 }}>
                  <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                    <Button
                      fullWidth
                      variant='contained'
                      color='secondary'
                      onClick={() => this.getItens(1)}
                    >
                      {<FormattedMessage id="filter" />}
                    </Button>
                  </Grid>

                  <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                    <Button
                      fullWidth
                      variant='outlined'
                      color='secondary'
                      onClick={(e) => {
                        e.preventDefault();

                        this.clearFields();
                      }}
                    >
                      {<FormattedMessage id="clear" />}
                    </Button>
                  </Grid>
                </Grid>
              </form>

              <MyMaterialTable
                title=""
                columns={this.state.columns}
                data={this.state.resultList}
              />

              <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                <Grid item xs={12} md={3}>
                  <Pagination
                    count={this.state.totalPages}
                    page={this.state.page}
                    onChange={this.onChangePaginate}
                  />
                </Grid>
                <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                  {this.state.pageStart} {<FormattedMessage id="to" />}{" "}
                  {this.state.pageEnd} {<FormattedMessage id="of" />}{" "}
                  {this.state.count} {<FormattedMessage id="register" />}
                </Grid>
              </Grid>
            </div>

            {this.state.loading && (
              <Overlay>
                <CircularProgress color="secondary" />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification}
            />
          </Container>
        </main>
        <Footer />
      </div>
    );
  }
}
BreakWorkMeList.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(componentActions, dispatch);
export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(BreakWorkMeList))
);

BreakWorkMeList.contextType = AbilityContext;
